export function getTiposBeca(){
  this.tipoBecaService.listadoBecasCicloActivo().then(tiposBeca => {
    this.tiposBeca = tiposBeca;
  }).catch(err => {
    console.log("Error" + err);
  });
}